
import { defineComponent } from 'vue';
import { epicContentComposition } from '../services';

export default defineComponent({
    setup () {
        const links = [
            {
                id: 'fact-sheet-healthcare-providers',
                url: 'https://'
            },
            {
                id: 'fact-sheet-patients-parents-caregivers',
                url: 'https://'
            },
            {
                id: 'fda-emergency-letter',
                url: 'https://'
            }
        ]

        return { ...epicContentComposition(), links };
    }
})
